(function() {
  function parseNumber(value) {
    var normalized = String(value || "").replace(/[^0-9.]/g, "");
    var parts = normalized.split(".");
    if (parts.length > 2) {
      normalized = parts[0] + "." + parts.slice(1).join("");
    }
    var parsed = parseFloat(normalized);
    return isFinite(parsed) ? parsed : NaN;
  }

  function formatMoney(amount) {
    if (!isFinite(amount)) {
      return "&ndash;";
    }

    return "$" + Math.round(amount).toLocaleString("en-US");
  }

  function formatRatio(ratio) {
    var rounded = Math.round(ratio * 10) / 10;
    return rounded.toFixed(1).replace(/\.0$/, "") + ":1";
  }

  function ratioBand(ratio) {
    if (ratio < 1) {
      return "below";
    }
    if (ratio < 3) {
      return "average";
    }
    if (ratio < 5) {
      return "good";
    }
    return "excellent";
  }

  function bandLabel(band) {
    return {
      below: "unprofitable",
      average: "below-target",
      good: "healthy",
      excellent: "strong"
    }[band];
  }

  function initCalculator(root) {
    var ids = ["aov", "freq", "life", "margin", "cac"];
    var inputs = {};
    ids.forEach(function(id) {
      inputs[id] = root.querySelector('[data-ltv-input="' + id + '"]');
    });

    var outputs = {
      big: document.querySelector('[data-ltv-output="ltv-big"]'),
      upside: document.querySelector('[data-ltv-output="ltv-upside"]'),
      profit: document.querySelector('[data-ltv-output="ltv-profit"]'),
      ratio: document.querySelector('[data-ltv-output="ltv-ratio"]'),
      pillar: document.querySelector('[data-ltv-output="route-pillar"]'),
      why: document.querySelector('[data-ltv-output="route-why"]'),
      scaleText: document.querySelector('[data-ltv-output="scale-text"]')
    };

    var segments = Array.prototype.slice.call(document.querySelectorAll("[data-ltv-band]"));

    function setHint(key, message, isBad) {
      var hint = root.querySelector('[data-ltv-hint="' + key + '"]');
      var input = inputs[key];

      if (!hint || !input) {
        return;
      }

      var defaultHint = hint.getAttribute("data-default-hint") || "";
      if (!message && defaultHint) {
        hint.textContent = defaultHint;
        hint.className = "hint";
        input.classList.remove("err");
        return;
      }

      hint.textContent = message || "";
      hint.className = "hint" + (isBad ? " bad" : "");
      input.classList.toggle("err", !!isBad);
    }

    function update() {
      var aov = parseNumber(inputs.aov.value);
      var freq = parseNumber(inputs.freq.value);
      var life = parseNumber(inputs.life.value);
      var margin = parseNumber(inputs.margin.value);
      var cac = parseNumber(inputs.cac.value);
      var valid = true;

      if (!(aov > 0)) {
        setHint("aov", "Enter your average order value.", true);
        valid = false;
      } else {
        setHint("aov", "");
      }

      if (!(freq > 0)) {
        setHint("freq", "Enter orders per year (e.g. 1.8).", true);
        valid = false;
      } else if (freq > 365) {
        setHint("freq", "That's a lot of orders. Double-check.", true);
        valid = false;
      } else {
        setHint("freq", "");
      }

      if (!(life > 0)) {
        setHint("life", "Enter how many years a customer stays.", true);
        valid = false;
      } else if (life > 50) {
        setHint("life", "Over 50 years looks off. Check the number.", true);
        valid = false;
      } else {
        setHint("life", "");
      }

      var hasMargin = inputs.margin.value.trim() !== "" && margin > 0;
      if (inputs.margin.value.trim() !== "" && (!(margin > 0) || margin > 100)) {
        setHint("margin", "Enter a margin between 1 and 100.", true);
        valid = false;
      } else {
        setHint("margin", "");
      }

      var hasCac = inputs.cac.value.trim() !== "" && cac > 0;
      if (inputs.cac.value.trim() !== "" && !(cac > 0)) {
        setHint("cac", "Enter a cost above 0, or leave it blank.", true);
        valid = false;
      } else {
        setHint("cac", "");
      }

      if (!valid) {
        return;
      }

      var revenueLtv = aov * freq * life;
      var profitLtv = hasMargin ? revenueLtv * (margin / 100) : null;
      var ratioBasis = profitLtv !== null ? profitLtv : revenueLtv;
      var ratio = hasCac ? ratioBasis / cac : null;
      var upside = aov * life;

      if (outputs.big) {
        outputs.big.innerHTML = formatMoney(revenueLtv);
      }

      if (outputs.upside) {
        outputs.upside.textContent = "one more order a year would add about " + formatMoney(upside) + " to that";
      }

      if (outputs.profit) {
        outputs.profit.innerHTML = profitLtv !== null ? formatMoney(profitLtv) : "&ndash; <span class='sub'>add margin</span>";
      }

      if (ratio !== null && outputs.ratio) {
        var band = ratioBand(ratio);
        outputs.ratio.innerHTML = formatRatio(ratio) + "<span class='sub'> &middot; " + bandLabel(band) + "</span>";
        segments.forEach(function(segment) {
          segment.classList.toggle("on", segment.getAttribute("data-ltv-band") === band);
        });
        if (outputs.scaleText) {
          outputs.scaleText.innerHTML = "Your store, at <b>" + formatRatio(ratio) + "</b>, sits in the <b>" + bandLabel(band) + "</b> band.";
        }
      } else {
        if (outputs.ratio) {
          outputs.ratio.innerHTML = "&ndash; <span class='sub'>add CAC</span>";
        }
        segments.forEach(function(segment) {
          segment.classList.remove("on");
        });
        if (outputs.scaleText) {
          outputs.scaleText.textContent = "Add your acquisition cost to see your LTV:CAC ratio.";
        }
      }

      if (outputs.pillar && outputs.why) {
        if (freq < 1.4) {
          outputs.pillar.textContent = "Retention · Purchase Loop";
          outputs.why.textContent = "Most of your customers buy once and never come back. The single biggest lever on lifetime value is a reliable second order.";
        } else if (life < 1.5) {
          outputs.pillar.textContent = "Retention · Trigger Timing";
          outputs.why.textContent = "Customers don't stick around long. A planned win-back and a reason to return stretches lifespan, and lifespan compounds everything else.";
        } else if (ratio !== null && ratio < 3) {
          outputs.pillar.textContent = "Acquisition · Efficiency";
          outputs.why.textContent = "Your LTV:CAC is under 3:1. You're paying too much to win a customer for what they're currently worth. Lift LTV before you scale spend.";
        } else if (hasMargin && margin < 35) {
          outputs.pillar.textContent = "Conversion · Offer Design";
          outputs.why.textContent = "Thin margins mean even loyal customers don't add up to much. The fix is the offer and the value ladder, not more traffic.";
        } else {
          outputs.pillar.textContent = "Retention · Scale";
          outputs.why.textContent = "Your customers are worth holding on to. With the repeat behaviour you've got, the lever now is winning more of the same.";
        }
      }
    }

    ids.forEach(function(id) {
      if (inputs[id]) {
        inputs[id].addEventListener("input", update);
      }
    });

    update();
  }

  document.addEventListener("DOMContentLoaded", function() {
    var root = document.querySelector("[data-ltv-calculator-root]");
    if (root) {
      initCalculator(root);
    }
  });
})();
